<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h4>{{ "admin.advertisers.title" | translate }}</h4>
      <app-search-field
        [form]="formFilter | asFormGroup"
        [filterOptions]="filterAdvertiser"
        [placeholder]="'placeholder.searchEmail' | translate"
        inputFormControlName="email"
        (emitSelectedOptions)="saveOption($event)"
      ></app-search-field>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive data-table">
      <form>
        <table class="table table-striped table-border-vertical">
          <thead>
            <tr>
              <ng-container *ngFor="let column of columns">
                <th
                  class="h-w-{{ column.width }}"
                  sortable="{{ column.key }}"
                  (sort)="onSort($event)"
                >
                  {{ column.label | translate }}
                </th>
              </ng-container>
              <th>{{ "admin.advertisers.status" | translate }}</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody *ngIf="!(loading$ | async)">
            <tr *ngFor="let advertiser of resultFilterAdvertiser.advertisers">
              <ng-template #none>
                <td>
                  {{ "undefined" | translate }}
                </td>
              </ng-template>
              <td *ngIf="advertiser.companyName != null; else none">
                <p>{{ advertiser.companyName }}</p>
              </td>
              <td
                *ngIf="
                  advertiser.firstName != null && advertiser.lastName != null;
                  else none
                "
              >
                <p>{{ advertiser.firstName + " " + advertiser.lastName }}</p>
              </td>
              <td *ngIf="advertiser.phone != null; else none">
                <p>{{ advertiser.phone }}</p>
              </td>
              <td *ngIf="advertiser.phone != null; else none">
                <p>{{ advertiser.email }}</p>
              </td>
              <td *ngIf="advertiser.phone != null; else none">
                <p>{{ advertiser.creationDate | localizedDate : "short" }}</p>
              </td>
              <td>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeByAdvertiserStatus(advertiser.status)
                  "
                >
                  {{
                    "enumMapping.advertiser.status." + advertiser.status
                      | translate
                  }}
                </span>
              </td>
              <td>
                <app-drop-zone-options
                  [value]="advertiser.status"
                  [options]="filteredAdvertiserActions"
                  (optionSelected)="saveAction($event, advertiser)"
                  (menuOpened)="onOpenMenu(advertiser.status)"
                ></app-drop-zone-options>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div
          *ngIf="count == 0 && !(loading$ | async) && !forbidden"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
        <div *ngIf="(loading$ | async) && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
      </form>
    </div>
    <app-pager
      [count]="count"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
    ></app-pager>
  </div>
</div>
